import {Component, OnInit} from '@angular/core';
import {NaviosService} from "./navios.service";
import {NaviosModel} from "./navios.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-navios',
  templateUrl: './navios.component.html'
})
export class NaviosComponent extends Components implements OnInit {

  navios: NaviosModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private naviosService: NaviosService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'navios'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.naviosService.getPaginacao(1,this.itensPorPagina)
      .subscribe(data => {
        this.navios = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];

        if (this.global.debug) {
          console.log(this.navios);
        }
      },
      error => {
        this.func.showErro(error.json());
      });


  }

  delete(navio) {
    let navios = this.navios;
    let naviosService = this.naviosService;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarNavio')+navio.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(this.global.debug == true){
          console.log(navios);
        }

        let index = navios.indexOf(navio);
        navios.splice(index, 1);

        naviosService.apagar(navio.id)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              this.navios = navios;
            },
            err => {
              // Revert the view back to its original state
              navios.splice(index, 0, navio);
              this.navios = navios;

              this.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.naviosService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.navios = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
      },
      error => {
        this.func.showErro(error.json());
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/navios/navios.component.ts